import { render, staticRenderFns } from "./property-results.vue?vue&type=template&id=4921b7a1"
import script from "./property-results.vue?vue&type=script&lang=js"
export * from "./property-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports